import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withHandlers, compose } from 'recompose';
import { goBack } from 'react-router-redux';
import { connect } from 'react-redux';

import Button from '../buttons/Button';
import Icon from '../icons/Icon';

import './ModalBackButton.scss';

const mapDispatchToProps = (dispatch) => ({
    goBackHistory: () => dispatch(goBack()),
});

const ModalBackButton = ({ showBack, handleBackClick, className, title = 'Back' }) => {
    if (!showBack) return null;

    return (
        <Button onClickFn={handleBackClick} className={classNames('ModalBackButton', className)}>
            <span>
                <Icon name="chevron-left" />
            </span>{' '}
            {title}
        </Button>
    );
};

ModalBackButton.propTypes = {
    showBack: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    handleBackClick: PropTypes.func,
    className: PropTypes.string,
    title: PropTypes.string,
};

const enhance = compose(
    connect(null, mapDispatchToProps),
    withHandlers({
        handleBackClick:
            ({ goBackHistory }) =>
            (event) => {
                goBackHistory();
            },
    }),
);

export default enhance(ModalBackButton);
